import * as React from 'react';
import { Typography } from '@mui/material';
import PricingCard from '../elements/pricing-card';
import { PricingPlan } from '../../types/pricing-plan';
import { TrustpilotWidget } from '../elements/trustpilot-widget';
import Grid from '@mui/material/Grid2';
import { EventBus } from '@/shared/utils';
import {
  DynamicPageEventKeys,
  DynamicPageEvents,
} from 'src/components/containers/dynamic-page/events';
import { useSubscriptionStore } from '../../store/subscription-store';
import { GuestCheckoutSubscriptionModal } from '../elements/guest-checkout-subscription-modal';
import { CheckoutSubscription } from 'src/components/containers/dynamic-page/types';
import { useServerAuth } from '@/auth';

interface PriceList {
  title: string;
  subscriptionCards: PricingPlan[] | null;
  disclaimer: string;
}

interface SectionPricesListProps {
  element: PriceList;
  eventBus: EventBus<DynamicPageEvents>;
}

export const SectionPricesList: React.FC<SectionPricesListProps> = ({ element, eventBus }) => {
  const subscriptionsOptions = useSubscriptionStore((state) => state.subscriptionsOptions);
  const { user } = useServerAuth();
  const [modalOpen, setModalOpen] = React.useState<CheckoutSubscription | undefined>();

  React.useEffect(() => {
    eventBus.emit(DynamicPageEventKeys.subscription.list, undefined);
  }, [eventBus]);

  return (
    <div className="py-8 md:py-16 px-4 md:px-8 lg:px-10 space-y-8">
      <div className="space-y-4 max-w-[1260px] mx-auto">
        <div className="space-y-10">
          <Typography variant="h2" component="h2" className="text-center">
            {element.title}
          </Typography>
          <Grid container spacing={{ xs: 2 }} className="w-full m-auto" alignItems="stretch">
            {!!element.subscriptionCards?.length &&
              element.subscriptionCards.map((plan) => (
                <Grid key={plan.id} size={{ xs: 12, md: 4 }}>
                  <PricingCard
                    {...plan}
                    eventBus={eventBus}
                    subscriptionOptions={subscriptionsOptions}
                    setModalOpen={setModalOpen}
                    isLogged={!!user?.email}
                  />
                </Grid>
              ))}
          </Grid>
        </div>
        <Typography variant="caption-500" component="p" color="textSecondary" textAlign="center">
          {element.disclaimer}
        </Typography>
      </div>
      <TrustpilotWidget height="120px" />

      <GuestCheckoutSubscriptionModal
        eventBus={eventBus}
        open={!!modalOpen}
        toggleModal={() => setModalOpen(undefined)}
        subscriptionData={modalOpen}
      />
    </div>
  );
};
